import { Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function SecureGatewayDivider() {
  const { t } = useTranslation('entity-portal');

  return (
    <Divider
      role="separator"
      aria-label={t('login.loginSecureGateway')}
      sx={{
        width: '100%',
        my: 0.5,
        '&::before, &::after': {
          borderColor: 'rgba(180, 190, 205, 0.55)',
        },
      }}
    >
      <Typography variant="overline" sx={{ color: 'text.secondary', px: 1 }}>
        {t('login.loginSecureGateway')}
      </Typography>
    </Divider>
  );
}
